/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";

export const COLORS = [
  theme.color.support.purple,
  theme.color.support.indigo,
  theme.color.support.cyan,
  theme.color.support.teal,
  theme.color.support.blue,
  theme.color.support.yellow,
  theme.color.support.pink,
  theme.color.support.red,
];
